import React from 'react';

const PricingPlans = ({ data }) => {
  return (
    <section id="pricing" className="p-80px-tb parallax bg-overlay opacity-5" style={{backgroundImage: 'url(' + process.env.PUBLIC_URL + '/assets/img/pricing-bg.jpg)'}}>
      <div className="container">
        {/* ページヘッダー */}
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold text-white m-20px-b">{data.pageTitle}</h2>
            <p className="lead text-white-50">{data.pageSubtitle}</p>
          </div>
        </div>

        {/* 協創割引セクション */}
        <div className="row m-50px-b">
          <div className="col-md-12">
            <div className="discount-section bg-light p-50px rounded">
              <h3 className="h3 font-weight-bold m-30px-b">{data.discountTitle}</h3>
              <p className="text-muted m-30px-b">{data.discountContent}</p>

              <div className="row">
                {data.discounts.map((discount, index) => (
                  <div key={index} className="col-lg-4 col-md-6 m-20px-b">
                    <div className="discount-card bg-white p-30px rounded h-100">
                      <h5 className="font-weight-bold m-15px-b">{discount.title}</h5>
                      <p className="text-muted m-15px-b">{discount.content}</p>
                      <div className="discount-badge">
                        <span className="badge badge-primary p-10px">{discount.discount}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 料金プラン一覧 */}
        <div className="row">
          <div className="col-md-12 m-30px-b">
            <h3 className="h3 font-weight-bold text-center">料金プラン一覧</h3>
          </div>
          {data.plans.map((plan, index) => (
            <div key={index} className="col-lg-6 col-xl-3 col-md-6 m-30px-b">
              <div className={`single-pricing text-center m-10px-tb ${plan.recommended ? 'featured-pricing' : ''}`}>
                <div className="pricing-head p-60px-lr lg-p-30px-lr">
                  <div className="pricing-head-text">
                    <div className="package-price">
                      <span className="price">{plan.price}</span>
                      <span className="validity">{plan.unit}</span>
                    </div>
                    <div className="package-name">
                      <h5>{plan.title}</h5>
                    </div>
                  </div>
                  <span className="wave"></span>
                  <span className="wave"></span>
                  <span className="wave"></span>
                </div>
                <div className="pricing-body p-60px-lr lg-p-30px-lr">
                  <p className="text-muted">{plan.description}</p>
                </div>
                <div className="pricing-footer p-60px-lr lg-p-30px-lr">
                  <a href={plan.url} className="btn btn-default btn-filled animated-btn">
                    このプランで相談する
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingPlans;